import TeamService from '@/services/TeamService'

const state = {
  inviteId: null
}

const mutations = {
  SET_INVITE_ID (state, inviteId) {
    state.inviteId = inviteId
  }
}

const actions = {
  async show (_, id) {
    const data = await TeamService.show(id)
    return data
  },
  async store ({ commit }, data) {
    const store = await TeamService.store(data)
    commit('auth/SET_TEAM', store, { root: true })
    return store
  },
  async join ({ commit }, { id }) {
    const update = await TeamService.show(`${id}/join`)
    commit('auth/SET_TEAM', update, { root: true })
    return update
  },
  async update ({ commit }, { id, data }) {
    const update = await TeamService.update(id, data)
    commit('auth/SET_TEAM', update, { root: true })
    return update
  },
  async destroy ({ commit }, { id }) {
    const destroy = await TeamService.destroy(id)
    commit('auth/SET_TEAM', destroy, { root: true })
    return destroy
  }
}

const getters = {
  getVerified (state) {
    return state.data.filter(item => item.verified)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
